export class EmergencySearchModel {
    patientName?: String;
    MRN?: String;
    gender?: String;
    dob?: Date;
    mobileNo?: String;
    identificationType?: String;
    identificationID?: String;
    offset?: String;
    limit?: String;
    unit?: String;
    country?: String;
    state?: String;
    city?: String;
    pincode?: String;
    startDate?: Date;
    endDate?: Date;
    status?: any;
    ward?: any;
    admissionNumber? : String;
    class? : any;
    doctor?:any;
    department?:any;
    bedcategory:any;
    Bed?:any;
    requestNo?:string;
    fromDate? : Date;
    disToDate? :Date;
    ExpectedfrDate? :Date;
    ExpectedToDate?:Date;
    businessStatus?:any;
}